// Terms pass B — AP contact CSV import with result counts and history.
import { useEffect, useState } from "react";
import { Card, call, errText, ghost } from "./shared";

function Result({ r }) {
  const notMatched = r.results.filter((x) => x.status !== "matched");
  return (
    <div className="text-sm space-y-1" data-testid="contact-import-result">
      <div><b data-testid="contact-import-matched">{r.matched}</b> matched · <b data-testid="contact-import-skipped">{r.skipped}</b> skipped · <b data-testid="contact-import-failed">{r.failed}</b> failed</div>
      {notMatched.length > 0 && (
        <ul className="text-xs text-[#374151] max-h-48 overflow-y-auto">
          {notMatched.map((x) => (
            <li key={x.line} data-testid={`contact-import-row-${x.line}`}>Line {x.line}: {x.company || "(no company)"} — {x.status}: {x.reason}
              {x.candidates?.length ? ` (${x.candidates.join(", ")})` : ""}{x.existing_email ? ` (kept ${x.existing_email}, file had ${x.new_email})` : ""}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function ContactImport({ slug, edit, onImported }) {
  const [last, setLast] = useState(null);
  const [hist, setHist] = useState([]);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => call("get", "/contacts/imports", slug).then((d) => setHist(d.items)).catch(() => {});
  useEffect(() => { load(); }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps
  const upload = async (file) => {
    if (!file) return;
    setErr(null); setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    try { setLast(await call("post", "/contacts/import", slug, fd)); load(); onImported(); }
    catch (e) { setErr(errText(e)); } finally { setBusy(false); }
  };
  return (
    <Card title="AP contact import (CSV)" testId="contact-import">
      <p className="text-xs text-[#6b7280]">Columns: company, ap_email (or email), optional contact_name and phone. Names must match a register account exactly; nothing is guessed. Existing emails are never overwritten.</p>
      {edit && <label className={`${ghost} inline-block cursor-pointer`}>{busy ? "Importing…" : "Upload CSV"}
        <input type="file" accept=".csv,text/csv" className="hidden" disabled={busy} onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} data-testid="contact-import-file" /></label>}
      {err && <div className="text-xs text-[#b91c1c]" data-testid="contact-import-error">{err}</div>}
      {last && <Result r={last} />}
      <div className="text-xs text-[#374151]" data-testid="contact-import-history">
        <div className="font-medium mb-1">Import history</div>
        {hist.length === 0 ? <div className="text-[#6b7280]">No imports yet.</div> : hist.map((h) => (
          <div key={h.id}>{h.at.slice(0, 16).replace("T", " ")} · {h.by} · {h.file_name || "file"} · {h.matched} matched / {h.skipped} skipped / {h.failed} failed</div>
        ))}
      </div>
    </Card>
  );
}
